import React, { useState } from "react";
import { excerpt, getAssets, htmlParse } from "@unisearch/helpers";
import { useRouter } from "next/router";
import { useRecoilValue } from "recoil";
import { authAtom } from "@_recoil/_state";
import { useSystemActions } from "@_recoil/_actions";
import styles from "./counsellor_thumb_section.module.scss";

export const CounsellorThumbSection = ({ counsellor }) => {
  const router = useRouter();
  const profileInfo = useRecoilValue(authAtom);
  const systemActions = useSystemActions();

  const viewDetails = (id) => {
    if (profileInfo && profileInfo.userTypeSlug) {
      router.push(`/app/student/counsellor/${id}`);
    } else {
      systemActions.setReturnUrl(router.asPath);
      return router.push({ pathname: "/signin" });
    }
  };

  const [toggleIds, setToggleIds] = useState([]);
  const handleToggle = (id) => {
    if (!id) return false;

    if (toggleIds.includes(parseInt(id))) {
      let newItem = toggleIds.filter(
        (filteredId) => filteredId != parseInt(id)
      );
      setToggleIds(newItem);
    } else {
      setToggleIds((prev) => [...prev, parseInt(id)]);
    }
  };

  return (
    <section>
      <div className="container">
        <div className={styles.heading_wrapper}>
          <h2>Our Team of Experts</h2>
          <p>
            UniSearch’s dedicated team of global counsellors have years of
            experience helping students like you turn their study abroad dreams
            into reality.
          </p>
        </div>
        <div className={styles.thumb_wrapper}>
          <ul className={styles.counsellor_thumb_lists}>
            {counsellor &&
              counsellor?.length > 0 &&
              counsellor?.map((item, i) => {
                const cbio = item?.bio ? excerpt(item.bio, 10000000) : "";
                return (
                  <li className={styles.counsellor_thumb_list} key={i}>
                    <div className={styles.counsellor_thumb_content}>
                      <div className={styles.counsellor_designation}>
                        Counsellor
                      </div>
                      <h4
                        className={styles.counsellor_name}
                      >{`${item?.firstName} ${item?.middleName} ${item.lastName}`}</h4>

                      {item?.workingCountryName?.length > 0 && (
                        <div className={styles.counsellor_region}>
                          <span>Regions: </span>
                          {item?.workingCountryName?.map((country, i, arr) => {
                            return (
                              <span key={`councount${i}`}>
                                {country?.name}
                                {arr.length === ++i ? null : ", "}
                              </span>
                            );
                          })}
                        </div>
                      )}

                      {item?.bio && (
                        <div
                          className={`${styles.counsellor_bio} from_texteditor_wrapper`}
                        >
                          {toggleIds.includes(parseInt(item?.id))
                            ? htmlParse(item?.bio)
                            : cbio?.slice(0, 245)}

                          {cbio.length > 245 && (
                            <span onClick={() => handleToggle(item?.id)}>
                              {toggleIds.includes(parseInt(item?.id)) ? (
                                <span className={styles.showmore}>
                                  show less
                                </span>
                              ) : (
                                <span className={styles.showmore}>
                                  ...read more
                                </span>
                              )}
                            </span>
                          )}
                        </div>
                      )}

                      {item?.showInDetailsPage > 0 && (
                        <button
                          onClick={() => viewDetails(item.id)}
                          className={`btn btn-secondary btn-bg`}
                        >
                          Book Now
                        </button>
                      )}
                    </div>
                    <div
                      className={`${styles.counsellor_thumb_image} ${
                        i % 2 === 1 ? styles.order_one : ""
                      }`}
                    >
                      <img
                        src={
                          item?.profileImageSrc ||
                          getAssets("assets/images/image_placeholder_big.webp")
                        }
                        alt={`${item?.firstName} ${item?.middleName} ${item.lastName}`}
                      />
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CounsellorThumbSection;
